import React ,{useRef} from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, SplitText);
const WhyChoose = () => {
    const container = useRef();
  useGSAP(
    () => {

      // let split = SplitText.create(".content_para_animation", {
      //   type: "words,chars,lines",
      // });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
          // markers: true
        },
      });
      
       tl.fromTo(
          ".workprocesspage_heading_animation",
          { opacity: 0, y: 60 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }
        ).fromTo(
          ".workprocesspage_card_animation",
          { opacity: 0, y: 100 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2,
            
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0").fromTo(
          ".workprocesspage_animation",
          { opacity: 0, y: 100 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2,
            
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          },"0"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
  return (
    <div className="wcu-area-2 " ref={container}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="title-area text-center me-xl-4 ms-xl-4">
              <span className="sub-title workprocesspage_heading_animation">
                <img src="/assets/img/icon/title_left.svg" alt="shape" />
                Work Process
              </span>
              <h2 className="sec-title style2 workprocesspage_heading_animation">
               Our Proven Process for Excellence
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6 workprocesspage_animation">
            <div className="wcu-thumb">
              <div className="wcu-thumb-1">
                <img src="/assets/img/normal/wcu-thumb-1-1.png" alt="img" />
              </div>
              <div className="wcu-shape jump">
                <img src="/assets/img/normal/1.png" alt="img" />
              </div>
              <div className="wcu-shape2 movingX">
                <img src="/assets/img/normal/2.png" alt="img" />
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="wcu-card-wrap">
              <div className="wcu-card workprocesspage_card_animation">
                <div className="icon">
                  <h3 className="pt-2">1.</h3>
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">
                    Networ Infra Tructure Solutions
                  </h4>
                  <p className="wcu-card-text">
                    IT Technology is a category a encompassing{" "}
                  </p>
                </div>
              </div>
              <div className="wcu-card workprocesspage_card_animation">
                <div className="icon">
                  {/* <img src="/assets/img/icon/wcu-icon_2-2.svg" alt="img" /> */}
                  <h3 className="pt-2">2.</h3>
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">
                    IT Training and most a the Education
                  </h4>
                  <p className="wcu-card-text">
                    IT Technology is a category a encompassing{" "}
                  </p>
                </div>
              </div>
              <div className="wcu-card workprocesspage_card_animation">
                <div className="icon">
                  <h3 className="pt-2">3.</h3>
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">
                    Technology solutions for a brighter
                  </h4>
                  <p className="wcu-card-text">
                    IT Technology is a category a encompassing
                  </p>
                </div>
              </div>
              <div className="wcu-card workprocesspage_card_animation">
                <div className="icon">
          <h3 className="pt-2">4.</h3>
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">IT Projec Manage Services</h4>
                  <p className="wcu-card-text">
                    IT Technology is a category a encompassing
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
